import { render, staticRenderFns } from "./ProductEditGeneralInfo.vue?vue&type=template&id=2c96ad5b&scoped=true&"
import script from "./ProductEditGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./ProductEditGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditGeneralInfo.vue?vue&type=style&index=0&id=2c96ad5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96ad5b",
  null
  
)

export default component.exports